import React, { Component } from "react";
import EditSlideshowDialog from "../../../components/settings/slideshow/EditSlideshowDialog";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";

class EditSlideshowContainer extends Component {
  state = {
    open: false,
    name: "",
    deleteConfirm: false,
  };

  handleChange = (e) => {
    let toUpdate = {};
    toUpdate[e.target.name] = e.target.value;
    this.setState(toUpdate);
  };

  toggleDialog = () => {
    this.setState({ open: !this.state.open });
  };

  UNSAFE_componentWillMount = () => {
    const slideshow = this.props.slideshow;
    if (slideshow) {
      this.updateState(slideshow);
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const slideshow = nextProps.slideshow;
    if (slideshow) {
      this.updateState(slideshow);
    }
  };

  updateState = (slideshow) => {
    this.setState({
      name: slideshow.name || "",
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    let name = this.state.name;
    if (this.props.slideshow.id === "0") {
      tournamentRef.update({ slideshowName: name });
    } else {
      let diaDoc = tournamentRef
        .collection("slideshows")
        .doc(this.props.slideshow.id);
      diaDoc.update({ name: name });
    }
    this.toggleDialog();
  };

  handleDelete = (e) => {
    e.preventDefault();
    if (this.state.deleteConfirm === false) {
      this.setState({ deleteConfirm: true });
    } else {
      this.toggleDialog();
      if (this.props.slideshow.id === this.props.selectedSlideshow) {
        this.props.selectSlideshow("0");
      }
      const db = window.firebase.firestore();
      let batch = db.batch();
      const tournamentRef = db
        .collection("tournaments")
        .doc(this.props.tournament[".key"]);
      batch.delete(
        tournamentRef.collection("slideshows").doc(this.props.slideshow.id)
      );
      this.props.dias.forEach((dia) => {
        batch.delete(tournamentRef.collection("dias").doc(dia.id));
      });

      batch.commit();
    }
  };

  render() {
    return (
      <div>
        <IconButton aria-label="Change" onClick={this.toggleDialog}>
          <CreateIcon style={{ height: 20, width: 20, position: "absolute" }} />
        </IconButton>

        <EditSlideshowDialog
          name={this.state.name}
          open={this.state.open}
          slideshow={this.props.slideshow}
          deleteConfirm={this.state.deleteConfirm}
          toggleDialog={this.toggleDialog}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          handleDelete={this.handleDelete}
          tournament={this.props.tournament}
        />
      </div>
    );
  }
}

export default EditSlideshowContainer;
